import React from 'react';
import { i18n } from 'core/i18n';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { formatAmountObject, formatAmount } from 'utilities/currencyHelper';
import {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    HYPHEN,
    VIRTUAL,
    VIA_T
} from 'constants/index';
import { getLastNChars } from 'utilities/stringHelper';

const { FormattedText, formatText, getLanguage } = i18n;

export const HireNewCreditCardSummary = ({
    immHireCardNameSelector,
    immHireCreditLimit,
    immHirePaymentMethod,
    immShippingAddressList,
    immPdfRevolvingPersistent,
    immAccounts,
    selectedAccount,
    cardType,
}) => {
    const limitObj = {
        amount: immHireCreditLimit.get('creditLimit'),
        currency: EURO_TEXT
    };
    const paymentMethod = {
        [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentFullPay')}`,
        [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredFixedFee')}`,
        [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardOpenCredit-summaryMethodOfPaymentDeferredVariableFee')}`
    };
    const paymentMethodType = immHirePaymentMethod.get('type');
    const paymentMethodText = paymentMethod[paymentMethodType];
    const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : '%';
    const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
        ? paymentMethodText
        : `${paymentMethodText} ${formatAmount(immHirePaymentMethod.get('value'), getLanguage(), 0)} ${paymentMethodSymbol}`;
    const addressValue = immShippingAddressList.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immShippingAddressList);
    const paymentMethodAmount = immHirePaymentMethod.get('value')
    const tin = immPdfRevolvingPersistent.getIn(['paramsInne', 'tin'])
    const tae = immPdfRevolvingPersistent.getIn(['paramsInne', 'tae'])
    const immAccount = immAccounts.getIn(['byId', selectedAccount]);
    const accountIban = getLastNChars(immAccount.get('iban'));
    const showCardName = cardType !== VIA_T && cardType !== VIRTUAL;
    const showShippingAddress = cardType !== VIRTUAL;
    return (
        <div className="hire-card-neruda-step-five__summary row">
            {showCardName && 
            <div className="col-xs-6 print-label">
            <div className="hire-card-neruda-step-five__summary-label">
                <FormattedText value={'hireCardNeruda-hireCardNeruda_summarySelectedName'} />
            </div>
                <div className="hire-card-neruda-step-five__summary-value">
                    {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                </div>
            </div>}
            <div className="col-xs-6">
                <div className="hire-card-neruda-step-five__summary-label">
                    <FormattedText value={'hireCardNeruda-hireCardNeruda_summarySelectedLimit'} />
                </div>
                <div className="hire-card-neruda-step-five__summary-value">
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
            </div>
            {__CONTACT_CENTER__ &&
                <>
                    <div className="col-xs-6">
                        <div className="hire-card-neruda-step-five__summary-label">
                            <FormattedText value={'hireCardSidebar-paymentMethodAmount'} />
                        </div>
                        <div className="hire-card-neruda-step-five__summary-value">
                            {paymentMethodAmount}

                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="hire-card-neruda-step-five__summary-label">
                            <FormattedText value={'hireCardSidebar-tin'} />
                        </div>
                        <div className="hire-card-neruda-step-five__summary-value">
                            {tin}
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="hire-card-neruda-step-five__summary-label">
                            <FormattedText value={'hireCardSidebar-tae'} />
                        </div>
                        <div className="hire-card-neruda-step-five__summary-value">
                            {tae}
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="hire-card-neruda-step-five__summary-label">
                            <FormattedText value={'hireCardSidebar-selectedAccount'} />
                        </div>
                        <div className="hire-card-neruda-step-five__summary-value">
                            <div>
                                <span>{immAccount.get('alias')}</span>
                                &nbsp;
                                <span>{accountIban}</span>
                            </div>
                        </div>
                    </div>
                </>

            }

            <div className="col-xs-6 print-label">
                <div className="hire-card-neruda-step-five__summary-label">
                    <FormattedText value={'hireCardNeruda-hireCardNeruda_summaryPaymentMethod'} />
                </div>
                <div className="hire-card-neruda-step-five__summary-value">
                    {paymentMethodValue}
                </div>
            </div>
            {showShippingAddress && 
            <div className="col-xs-6">
                <div className="hire-card-neruda-step-five__summary-label">
                    <FormattedText value={'hireCardNeruda-hireCardNeruda_summaryShippingAddress'} />
                </div>
                <div className="hire-card-neruda-step-five__summary-value">
                    {addressValue}
                </div>
            </div>}
        </div>
    );
};

